const locale = {
  placeholder: 'VybraÅ¥ Äas',
};

export default locale;
